export default __webpack_public_path__ + "static/media/tooltiparrow.4a2270db.svg";